<template>
	<div class="incenters">
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增"
				fontSize="14px" @btnclick="addckd">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" opwidth="72px" top="370px"
				:src="require('@/assets/icon/icon-update.png')" title="修改" :optional="editops" fontSize="14px"
				@btnclick="updateckd">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="shen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.revoke" title="弃审" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="DespatchExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="Import"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="指导视频" fontSize="14px" @btnclick="GuidanceVideo"
				:src="require('@/assets/icon/video.png')">
			</Commonbtn> <a
				style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="dowloadBtn">下载导入模版</a>

		</div>
		<div class="TableWidth">
			<Commontable ref="OutboudreRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom ref="dialogadd" width="1000px" :title="dialogindex==='add'?'新增出库单':'修改出库单'" :OKASCAN="false"
			:dialogVisible="dialogVisibleoutboundorder" @cancel="dialogVisibleoutboundorder = false">
			<div class="froms">
				<div style="border-bottom: 1px solid #f0f0f0;">
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
						fontSize="14px" @btnclick="addsave">
					</Commonbtn>
					<div style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库明细" fontSize="14px" @getFile="UnImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="dowload">下载导入模版</a>
					</div>
				</div>

				<div style="width: 960px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 15px;animation: shows 0.2s linear;overflow: hidden;"
					v-if="showorhide">
					<div v-for="(item , index) of formdatadialog" :key="index+'add'" style="display: inline-block;">
						<Commondropdownlist ref="outadd" :loading="loading" :selcoms="item.selcoms" :event="item.event"
							@remoteMethodtows="remoteMethodtows" :btx="item.btx" :key="index" :options="item.options"
							:minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft"
							:maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:width="item.width" :disabled="item.disabled">
						</Commondropdownlist>
					</div>
				</div>
			</div>
			<div style="width: 970px;">
				<AddDialogFromTable :wtypes="wtypes" :invClassCode="invClassCode" ref="AddDialog" :hospital="hospital"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick" width="500px"
					colnum=7 :comid="comid" :state="state" :tableData="tableData" height="100%">
				</AddDialogFromTable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="出库上报管理指导视频" :OKASCAN="false" :dialogVisible="dialogVisibGuidanceVideo"
			@cancel="cancelGuidanceVideo" @dialogOK="dialogOKGuidanceVideo">
			<VideoPlayer ref="outbouVideo" v-if="dialogVisibGuidanceVideo" :srcVideo="require('../../../../assets/video/outbou/outbou2.mp4')">
			</VideoPlayer>
		</DialogFrom>
		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesqsjg" @cancel="cancelqsjg"
			@dialogOK="dialogOKqsjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDataqsjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleshen" @cancel="cancelshen"
			@dialogOK="dialogOKshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条出库上报信息吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Dialog from '../../../../components/dialog.vue'
	import AddDialogFromTable from './components/addDialogFromTable.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import addformdatadialog from '../fromData/addformdatadialog'
	import editformdatadialog from '../fromData/editformdatadialog'
	import headerData from '../table/headerData'
	import headerDataTow from '../table/headerDataTow'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import VideoPlayer from '../../../../components/videoPlayer.vue'
	import Outboundreportmanagement from './outboundreportmanagement-bottom.vue'
	import {
		InventoryClassList,
		CusType,
		CustomerList,
		HospitalList,
		DespatchImportUnique,
		DespatchDownloadUniqueTemplet,
		DespatchEdit,
		HospitalInfo,
		wmsDespatchList,
		GetDespatchDetailByDPMIDs
	} from '@/api/home'


	import {
		ConsignOrderDownloadTemplet,
		ConsignOrderImport,
		ConsignOrderVerify,
		ConsignOrderUnVerify,
		ConsignOrderDelete,
		ConsignOrderExport,
		ConsignOrderImportDetail,
		ConsignOrderDownloadDetailTemplet,
		ConsignOrderAdd,
		ConsignOrderEdit,
		ConsignOrderInfo
	} from '@/api/newsapi'
	export default {
		name: 'outnoundreport',
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonBtngroup,
			AddDialogFromTable,
			CommonbtnUpLoad,
			VideoPlayer,
			Outboundreportmanagement
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				tableData: [],
				hospital: '',
				dialogVisibleoutboundorderedit: false,
				dialogVisibles: false,
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisibleqdel: false,
				dialogVisibledel: false,
				dialogVisibleoutboundorder: false,
				dialogVisiblesdrjg: false,
				dialogVisiblesqsjg: false,
				dialogVisibGuidanceVideo: false,
				Detailflag: true,
				editops: true,
				showorhide: true,
				rowboo: false,
				loading: false,
				comid: null,
				// optionalupdate: false,
				CusTypeFlog: null,
				tableDataqsjg: [],
				formdatadialog: [],
				editformdatadialog: [],
				comidarr: [],
				invClassCode: "",
				title: '',
				dialogindex: '',
				TerminalHospital: '',
				TerminalHospitalName: '',
				wtypes: 1,
				HosTypestate: null,
				headerData: [],
				headerDataTow: [],
				fromdatalists: [{
					inputdata: '',
					fontSize: '14px',
					color: '#333333',
					placeholder: '颜色说明',
					types: '',
					inputtype: 'selects',
					width: '110px',
				}, ],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
				},
				tableDatadrjg: [],
				AddTableSelectiondetailList: [],
				AddTableSelectiondetailUniqueList: [],
				state: [{
					title: '明细'
				}],
				CusTypeState: "",
				HospitalCode: "",
				CusCode: "",
				HospitalName: "",
				CusCodeName: "",
				tableData2: [],
				total2: 0,
				selectformparams: {},
				selectformdatalist: [],
				pageSize2: 20,
				pageindex2: 1,
				tableDataDetail: [],
				tableDataUnique: [],
				comidarr2: [],
				hiddenBtn: false,
				selectformdata: [{
						inputdata: '',
						title: '平台/经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '95px',
						inputflag: false
					},
					{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '95px',
						options: [],
						selcoms: false,
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "150px",
						lablewith: '85px'
					},
					{
						inputdata: '',
						title: '付款方名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '150px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: [],
					},

					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: [],
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "160px",
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '160px',
						lablewith: '80px',
						options: []
					},
					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '90px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '160px',
						lablewith: '70px'
					},
				],
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.formdatadialog = JSON.parse(JSON.stringify(addformdatadialog))
			this.editformdatadialog = JSON.parse(JSON.stringify(editformdatadialog))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 18) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 158) {
								this.qus = items.Nodes
							}
						})
					}
				})
				//console.log(this.qus, 'qus');
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'revoke') {
							this.qx.revoke = true
						}
					})
				}
				this.CusType()
			},
			async dowloadBtn() {
				let {
					data,
					code,
					message
				} = await ConsignOrderDownloadTemplet({})

				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载模板
			async dowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await ConsignOrderDownloadDetailTemplet({})
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 上传出库明细
			async UnImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ConsignOrderImportDetail(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					//console.log(this.$refs.AddDialog, 'adddialog');
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					// data.DetailList.map((item, index) => {
					//   this.$refs.AddDialog.tableDataDetail.push(item)
					// })
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 下载出库唯一码明细
			async Uniqdowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"

				let {
					data,
					code,
					message
				} = await DespatchDownloadUniqueTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 添加保存
			async addsave() {
				// if (!this.$refs.outadd[0].modelvalue) {
				// 	this.$message.warning("单据号不能为空！")
				// 	return
				// }
				if (!this.$refs.outadd[1].modelvalue) {
					this.$message.warning("寄售日期不能为空！")
					return
				}
				if (!this.$refs.outadd[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outadd[3].modelvalue) {
					this.$message.warning("寄售方向不能为空！")
					return
				}
				if (!this.$refs.outadd[4].modelvalue) {
					this.$message.warning("寄售公司不能为空！")
					return
				}

				let params = {
					COCode: this.$refs.outadd[0].modelvalue,
					CODate: this.$refs.outadd[1].modelvalue,
					InvClass: this.$refs.outadd[2].modelvalue,
					ReturnFlag: this.$refs.outadd[3].modelvalue,
					Hospital: this.$refs.outadd[4].modelvalue,
					Remark: this.$refs.outadd[5].modelvalue,
					DetailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传
				};

				if (params.DetailList.length) {
					let newarr = [],
						msg = '';

					for (var i = 0; i < params.DetailList.length; i++) {
						if (!params.DetailList[i].Quantity) {
							msg = `${params.DetailList[i].InvCode}:数量不能为空`
							break;
						}
						newarr.push({
							InvCode: params.DetailList[i].InvCode,
							Batch: params.DetailList[i].Batch,
							Quantity: params.DetailList[i].Quantity,
						})
					}
					if (msg) {
						this.$message.warning(msg);
						return;
					}
					params.DetailList = newarr;
				}
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				console.log(params);

				if (this.dialogindex === "add") {
					let {
						code,
						data,
						message
					} = await ConsignOrderAdd(params)
					loading.close();
					if (code == 0) {
						this.$message({
							type: 'success',
							message: '新增成功'
						});
						this.$parent.ConsignOrderList()
						this.dialogVisibleoutboundorder = false
						this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
						location.reload();
					} else if (code == 101) {
						this.$message({
							type: 'warning',
							message: message
						});
					} else {
						if (data.length) {
							this.$alert(`${data.join('<br/>')}`, '提示', {
								dangerouslyUseHTMLString: true,
								showConfirmButton: false
							});
						} else {
							this.$message({
								type: 'error',
								message: message
							});
						}
					}
				} else {
					params.comid = this.comid;
					let {
						code,
						data,
						message
					} = await ConsignOrderEdit(params)
					loading.close();
					if (code == 0) {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.$parent.ConsignOrderList()
						this.dialogVisibleoutboundorder = false
						this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
						// this.$emit('rowDetail', {
						// 	COMID: this.comid
						// })
						location.reload();
					} else if (code == 101) {
						this.$message({
							type: 'warning',
							message: message
						});
					} else {
						if (data.length) {
							this.$alert(`${data.join('<br/>')}`, '提示', {
								dangerouslyUseHTMLString: true,
								showConfirmButton: false
							});
						} else {
							this.$message({
								type: 'error',
								message: message
							});
						}
					}
				}
			},
			// 详情
			async ConsignOrderInfo() {
				let {
					code,
					data
				} = await ConsignOrderInfo({
					comid: this.comid
				})
				if (code == 0) {
					this.$refs.outadd[0].modelvalue = data.COCode
					this.$refs.outadd[1].modelvalue = data.CODate
					this.$refs.outadd[2].modelvalue = data.InvClass
					this.$refs.outadd[3].modelvalue = data.ReturnFlag + ''
					this.$refs.outadd[4].modelvalue = data.Hospital
					this.$refs.outadd[5].modelvalue = data.Remark;
					this.tableData = data.DetailList;
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList;
					this.$refs.outadd[4].options = [{
						key: data.Hospital,
						value: data.HospitalName
					}]
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdatadialog[2].options = []
					this.editformdatadialog[2].options = []
					let arr = [];
					data.data.map((item, index) => {
						arr.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
					this.formdatadialog[2].options = arr;
					this.editformdatadialog[2].options = arr;
				}
			},
			// 导入
			async Import(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ConsignOrderImport(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
				this.$parent.ConsignOrderList()
			},
			// 判断修改是否可用
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					// this.CusTypeState = data.CusType
					if (data.CusType == "") {
						this.editops = true //测试中
						this.CusTypeFlog = 0
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
					}
				}
			},
			addclick() {
				this.hospital = this.$refs.outadd[3].modelvalue == 1 ? Number(this.$refs.outadd[4].modelvalue) : '0';
				this.invClassCode = this.$refs.outadd[2].modelvalue;
			},
			dialogOKinvoicephoto() {},
			cancelinvoicephoto() {},
			// 删除
			async wmsDespatchDelete() {
				let {
					code,
					message,
					data
				} = await ConsignOrderDelete({
					COMIDs: this.comidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.comidarr.length = 0
					this.$parent.ConsignOrderList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "删除结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 审核
			async wmsDespatchVerify() {
				let {
					code,
					message,
					data
				} = await ConsignOrderVerify({
					COMIDs: this.comidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功'
					});
					this.comidarr.length = 0
					this.$parent.ConsignOrderList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.$message({
						type: 'success',
						message: message
					});
					this.$parent.ConsignOrderList()
				} else {
					this.title = "审核结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 弃审
			async wmsDespatchUnVerify() {
				let {
					code,
					message,
					data
				} = await ConsignOrderUnVerify({
					COMIDs: this.comidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功'
					});
					this.comidarr.length = 0
					this.$parent.ConsignOrderList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.$message({
						type: 'success',
						message: message
					});
					this.comidarr.length = 0
					this.$parent.ConsignOrderList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "弃审结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			//多选
			handleSelectionChange(val) {
				if (val) {
					this.comidarr = []
					// this.rowboo = true
					val.map((item, index) => {
						this.comidarr.push(item.COMID)
					})
				} else {
					this.rowboo = false
				}

			},
			//多选
			handleSelectionChange2(val) {
				if (val) {
					this.comidarr2 = []
					// this.rowboo = true
					val.map((item, index) => {
						this.comidarr2.push(item.COMID)
					})
				} else {
					this.rowboo = false
				}
			},
			handleSelectionChangeAddDialogFromTable(val) {
				this.AddTableSelectiondetailList = val
			},
			handleSelectionChanges() {},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			addckd(val) {
				this.HosTypestate = 1
				this.dialogindex = "add"
				this.inventoryClassList()
				this.dialogVisibleoutboundorder = true
				this.$emit('addckd', val)
				return
			},
			updateckd() {
				if (this.rowboo == true) {
					this.ConsignOrderInfo()
					this.inventoryClassList()
					this.dialogVisibleoutboundorder = true
					this.dialogindex = "update"
					this.$emit('updateckd')
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});

			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false

			},
			select() {

			},
			reset() {

			},
			//付款方
			async remoteMethodtows(query) {
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[4].options.push(obj)
					})
				}
			},
			onRowClick(val) {
				this.rowboo = true
				this.comid = val.COMID
				//console.log(val, "val")
				if (val.Status == 1) {
					this.editops = true
				}
				if (val.Status == 0) {
					this.editops = false
				}
				this.$emit("onRowClick", val)
			},
			DespatchExport() {
				this.$emit('DespatchExport')
			},
			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				// this.dialogVisibles = false
			},
			dialogOK() {
				// this.dialogVisibles = false
			},
			shen() {
				if (this.comidarr.length > 0) {
					this.dialogVisibleshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要审核的数据(多选)！'
				});
			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			dialogOKshen() {
				this.wmsDespatchVerify()
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.comidarr.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});


			},
			dialogOKqshen() {
				this.wmsDespatchUnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			del() {
				if (this.comidarr.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			dialogOKdel() {
				this.wmsDespatchDelete()
				this.dialogVisibledel = false
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			cancelqsjg() {
				this.dialogVisiblesqsjg = false
			},
			dialogOKqsjg() {
				this.dialogVisiblesqsjg = false
			},
			GuidanceVideo() {
				this.dialogVisibGuidanceVideo = true
			},
			cancelGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
			dialogOKGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			}
		},
		watch: {
			dialogVisibleoutboundorder: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.outadd.map((item, index) => {
							item.modelvalue = ''
						})
						this.formdatadialog[2].disabled = false;
						this.formdatadialog[2].inputdata = '';
						this.formdatadialog[3].disabled = false;
						this.formdatadialog[3].inputdata = '';
						this.formdatadialog[4].disabled = false;
						this.formdatadialog[4].inputdata = '';
						this.$refs.AddDialog.tableDataDetail.length = 0
						this.$refs.AddDialog.tableDataDetailunNo.length = 0
						this.$refs.AddDialog.tableDataDetailUnique.length = 0
					}
				},
				deep: true
			},
			dialogVisibGuidanceVideo: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						// 弹窗关闭暂定视频
						this.$refs.outbouVideo.$refs.videoPlayer.pause()
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.froms {
			width: 100%;

			.inputtopt {
				width: 980px;
				height: 90px;
				// box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
				border-bottom: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				animation: shows 0.2s linear;
				overflow: hidden;
			}

			.inputtops {
				width: 980px;
				height: 0;
				// box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
				border-bottom: 1px solid #f0f0f0;
				border-top: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				overflow: hidden;
				// animation: hides 0.5s ease-in;
			}
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.drop-down-link {
		margin: 10px;
		width: 100%;
		height: 32px;
		line-height: 32px;
		color: rgb(0, 0, 0);
		font-size: 14px;
		//background-color: rgb(249, 250, 252);
		border: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		//
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: rgb(255 235 235);
		color: #606266;
	}

	/deep/.el-checkbox__label {
		color: rgb(51, 51, 51);
		font-weight: 400;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: rgb(51, 51, 51);
		font-weight: 400;
	}
</style>